import api from '../axios/axiosConfig';

export const forgotPassword = async (email: string, app_id: number = 1) => {
    try {
        const response = await api.get(`/ResetPassword/${email}?app_id=${app_id}`);
        return response
    } catch (error: any) {
        throw error;
    }
};